var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __decorateParam = (index, decorator) => (target, key) => decorator(target, key, index);

// counter.ts
import { Int } from "@adornis/baseql/baseqlTypes.js";
import { Arg, Entity, Field, Mutation, Query } from "@adornis/baseql/decorators.js";
import { MongoEntity } from "@adornis/baseql/entities/mongoEntity.js";
import { getRawCollection } from "@adornis/baseql/server/collections.js";
var Counter = class extends MongoEntity {
  static getIncrementingNumber(key) {
    return async (gqlFields) => {
      const collection = await getRawCollection(this._collectionName);
      const result = await collection.findOneAndUpdate(
        { key },
        { $inc: { counter: 1 }, $setOnInsert: { key } },
        { returnDocument: "after", upsert: true }
      );
      return result.counter;
    };
  }
  static getCurrentCounter(key) {
    return async (gqlFields) => {
      const collection = await getRawCollection(this._collectionName);
      return (await collection.findOne({ key }))?.counter ?? 0;
    };
  }
};
Counter._class = "Counter";
Counter._collectionName = "counter";
__decorateClass([
  Field((type) => String)
], Counter.prototype, "key", 2);
__decorateClass([
  Field((type) => Int)
], Counter.prototype, "counter", 2);
__decorateClass([
  Mutation((type) => Int),
  __decorateParam(0, Arg("key", (type) => String))
], Counter, "getIncrementingNumber", 1);
__decorateClass([
  Query((type) => Int),
  __decorateParam(0, Arg("key", (type) => String))
], Counter, "getCurrentCounter", 1);
Counter = __decorateClass([
  Entity()
], Counter);
export {
  Counter
};
